module.exports = __webpack_public_path__ + "static/event_4-d03ff578596d4c08958877680e590e83.png";